export default {
    text: 'Sites',
    path: '/site',
    icon: 'site.svg',
    children: [
        {
            text: 'Sites',
            path: '/site/sites',
            children: [],
            permissions: {
                WSITE: 'READ'
            }
        },
        {
            text: 'Widgets',
            path: '/site/widgets',
            children: [],
            permissions: {
                WWIDGET: 'READ'
            }
        },
        {
            text: 'Templates',
            path: '/site/templates',
            children: [],
            permissions: {
                WTEMPLATE: 'READ'
            }
        },
        {
            text: 'Pages',
            path: '/site/pages',
            children: [],
            permissions: {
                WPAGE: 'READ'
            }
        },
        {
            text: 'Routes',
            path: '/site/routes',
            children: [],
            permissions: {
                WROUTING: 'READ'
            }
        },
        {
            text: 'Menus',
            path: '/site/menus',
            children: [],
            permissions: {
                WMENU: 'READ'
            }
        },
        {
            text: 'Translations',
            path: '/site/translations',
            children: [],
            permissions: {
                OTRANSLATION: 'READ'
            }
        },
        {
            text: 'Redirects',
            path: '/site/redirects',
            children: [],
            permissions: {
                WREDIRECT: 'READ'
            }
        },
        {
            text: 'Config Variables',
            path: '/site/config-variables',
            children: [],
            permissions: {
                ACONFIG_VARIABLES: 'READ'
            }
        },
        {
            text: 'Deployments',
            path: '/site/deployments',
            children: [],
            permissions: {
                WWIDGET: 'READ'
            }
        }
    ],
    permissions: {
        WSITE: 'READ'
    }
};
